import(/* webpackMode: "eager", webpackExports: ["HeroButton"] */ "/workspace/src/components/HomePageClientParts.tsx");
